import { replaceSerCodigoIMG } from "../QueryParams";
import agendaApiConfig from "./agendaApiConfig";
import ManageStorage from "src/shared/global/manageStorage";

const TipoExamenService = {
  async getAll() {
    //return await agendaApiConfig.get("/imagenologia/tipo_examen");
    let query = {};
    console.log(process.env.REACT_APP_SERVICIO_IMG);
    // if(process.env.REACT_APP_SERVICIO_IMG == ""){
    //     query = null;
    // }else{
    //     query =  {ser_codigo : process.env.REACT_APP_SERVICIO_IMG };
    // }
    let clinica = ManageStorage.getValueFromStorage("clinica");
    query = replaceSerCodigoIMG(clinica, query);
    console.log(query, "00");
    
    return await agendaApiConfig.get("/imagenologia/tipo_examen", {
      params: {
        ...query,
      },
    });
  },
  async getExamenes(codeExamen = 0) {
    //return await agendaApiConfig.get(`/imagenologia/${codeExamen}/examen`);
    let query = {};
    // console.log("getExamenes => ", process.env.REACT_APP_SERVICIO_IMG);
    // if(process.env.REACT_APP_SERVICIO_IMG == ""){
    //     query = null;
    // }else{
    //     query =  {ser_codigo : process.env.REACT_APP_SERVICIO_IMG };
    // }
    let clinica = ManageStorage.getValueFromStorage("clinica");
    query = replaceSerCodigoIMG(clinica, query);

    return await agendaApiConfig.get(`/imagenologia/${codeExamen}/examen`, {
      params: {
        ...query,
      },
    });
  },
};

export default TipoExamenService;
